(function () {
    if (!window.cxm) {
        window.cmx = {};
    }
    window.cmx.inlineForms = {
        turnEditMode: function (e) {
            let target = e.target;
            let inlineForm = this.findParentByClass(target, 'cmx-forms-inline');
            inlineForm.classList.add('on');
            return true;
        },
        shutEditMode: function (e) {
            let target = e.target;
            let inlineForm = this.findParentByClass(target, 'cmx-forms-inline');
            inlineForm.classList.remove('on');
            return true;
        },
        findParentByClass: function (element, className) {
            let directParent = element.parentNode;
            if (directParent.classList.contains(className)) {
                return directParent;
            } else {
                return this.findParentByClass(directParent, className);
            }
        }
    }
}());

// SELECT SCRIPTS
(function () {
    function findParentByClass(element, className) {
        let directParent = element.parentNode;
        if (directParent.classList.contains(className)) {
            return directParent;
        } else {
            return findParentByClass(directParent, className);
        }
    }
    window.singleSelectShowOptions = function (e) {
        //  function ot hide onclick
        let hideOnClick = function (e, zeElement, zeInput) {
            function hideFunction(e) {
                zeElement.classList.add('hidden');
                zeInput.classList.remove('active')
                document.removeEventListener('click', hideFunction);
            }
            document.addEventListener('click', hideFunction);
        };

        // the input
        let input = e.target;
        // the dropdown
        let dropdown = input.parentNode.querySelector('.cmx-select-dd');

        // toggle the class
        if (dropdown.classList.contains('hidden')) {

            // lets show
            dropdown.classList.remove('hidden');
            input.classList.add('active');

            // add event listener on click outside
            setTimeout(function () {
                hideOnClick(e, dropdown, input);
            }, 100);

        } else {
            // lets hide
            dropdown.classList.add('hidden');
            input.classList.remove('active');
        }

    }
    window.selectSingleUpdate = function (e) {
        let selection = e.target;
        let selectionText = selection.textContent.replace(/^\s+|\s+$|\s+(?=\s)/g, "");
        let selectionValue = selection.dataset['selectValue'];

        if (!selectionValue) {
            selectionValue = selectionText;
        }

        let currentActive = selection.parentNode.querySelector('.selected');

        if (currentActive) {
            currentActive.classList.remove('selected');
            currentActive.setAttribute('aria-selected', 'false');
        }

        selection.classList.add('selected');
        selection.setAttribute('aria-selected', 'true');

        let wrap = findParentByClass(selection, 'cmx-select');
        let output = wrap.querySelector('.cmx-select__output');
        let valueOutput = wrap.querySelector('.cmx-select__value-output');

        output.value = selectionText;
        valueOutput.value = selectionValue;

    }

    window.selectShowOptions = function (e) {
        //  function ot hide onclick outside
        let hideOnClickOutside = function (e, zeElement, zeInput) {
            function isWithin(element) {
                if (element) {
                    if (element === zeElement) {
                        return true;
                    } else {
                        return isWithin(element.parentNode);
                    }
                } else {
                    return false;
                }
            }
            function hideFunction(e) {
                let withinContainer = isWithin(e.target);

                if (!withinContainer) {
                    zeElement.classList.add('hidden');
                    zeInput.classList.remove('active')
                    document.removeEventListener('click', hideFunction);
                }
            }
            document.addEventListener('click', hideFunction);
        };

        // the input
        let input = e.target;
        // the dropdown
        let dropdown = input.parentNode.querySelector('.cmx-select-dd');

        // toggle the class
        if (dropdown.classList.contains('hidden')) {

            // lets show
            dropdown.classList.remove('hidden');
            input.classList.add('active');

            // add event listener on click outside
            setTimeout(function () {
                hideOnClickOutside(e, dropdown, input);
            }, 100);

        } else {
            // lets hide
            dropdown.classList.add('hidden');
            input.classList.remove('active');
        }

    }
    window.selectInputUpdate = function (e) {
        let checkbox = e.target;
        let mirrorInputSelector = '[data-mirror-checkboxes="' + checkbox.name + '"]';

        let input = document.querySelector(mirrorInputSelector);

        let checkedCheckboxes = document.querySelectorAll('input[name="' + checkbox.name + '"]:checked');

        let inputValueArray = [];
        for (let checkedCheckbox of checkedCheckboxes) {
            inputValueArray.push(checkedCheckbox.parentNode.textContent.replace(/^\s+|\s+$|\s+(?=\s)/g, ""));
        }
        input.value = inputValueArray.join(', ');
    }
    window.checkAll = function (e) {
        let mainCheck = e.target;
        let allChecks = document.querySelectorAll('input[type="checkbox"][name="' + mainCheck.dataset['checkAllTarget'] + '"]');
        for (let check of allChecks) {
            check.checked = mainCheck.checked;
            selectInputUpdate({ target: check });
        }
    };
    window.filterSelect = function (e) {
        let searchInput = e.target;
        let searchQuery = searchInput.value.toLowerCase();
        let dd = findParentByClass(searchInput, 'cmx-select-dd');
        let options = dd['options'];
        if (!options) {
            let domOptions = dd.querySelectorAll('.cmx-select-dd__option');
            let domOptionsArray = [];
            for (let domOption of domOptions) {
                let optionText = domOption.textContent.replace(/^\s+|\s+$|\s+(?=\s)/g, "").toLowerCase();
                domOptionsArray.push({
                    element: domOption,
                    text: optionText
                });
            }
            dd['options'] = domOptionsArray;
            options = domOptionsArray;
        }
        let filtered = false;
        let noResults = true;
        options.map((option) => {
            if (option.text.indexOf(searchQuery) < 0) {
                filtered = true;
                option.element.classList.add('hidden');
            } else {
                noResults = false
                option.element.classList.remove('hidden');
            }
        });
        if (filtered) {
            dd.classList.add('filtered');
        } else {
            dd.classList.remove('filtered');
        }
        if (noResults) {
            dd.classList.add('no-results');
        } else {
            dd.classList.remove('no-results');
        }
    }
}());

// DEMO SCRIPTS
(function () {
    if (!window.demo) {
        window.demo = {};
    }
    window.demo.inlineForms = {
        saveEdits: function (e) {
            let target = e.target;
            let inputWraps = this.findParentByClass(target, 'cmx-forms-inline').querySelectorAll('.cmx-forms-inline__input');

            for (const wrap of inputWraps) {
                let input = wrap.querySelector('.cmx-form-control');
                if (input) {
                    let value = input.value;
                    let label = wrap.parentNode.querySelector('.cmx-forms-inline__value');

                    label.textContent = value;
                }
            }

            window.cmx.inlineForms.shutEditMode(e);
        },
        findParentByClass: function (element, className) {
            let directParent = element.parentNode;
            if (directParent.classList.contains(className)) {
                return directParent;
            } else {
                return this.findParentByClass(directParent, className);
            }
        }
    };
}());